import { GoGoal } from "react-icons/go";
import { GrPlan } from "react-icons/gr";
import { FaVolleyball, FaBasketball } from "react-icons/fa6";
import {
  IoIosStats,
  IoIosSettings,
  IoIosPerson,
  IoIosPersonAdd,
  IoIosEyeOff,
  IoIosLogIn,
  IoIosLogOut,
} from "react-icons/io";
import {
  IoSettingsSharp,
  IoFootball,
  IoFootballOutline,
} from "react-icons/io5";
import {
  FaChartBar,
  FaCalendarAlt,
  FaFacebookMessenger,
  FaUsersCog,
  FaListAlt,
  FaTrophy,
  FaUsers,
} from "react-icons/fa";
import { ImStatsDots } from "react-icons/im";
import { MdPlace, MdSportsRugby, MdAdminPanelSettings } from "react-icons/md";

import user01 from "../assets/user01.png";
import user02 from "../assets/user02.png";
import user03 from "../assets/user03.png";

export const links = [
  {
    href: "/dashboard",
    icon: FaChartBar,
    text: "Dashboard",
  },
  {
    href: "/campeonatos",
    icon: FaTrophy,
    text: "Campeonatos",
    badge: {
      text: "Pro",
      color: "bg-gray-100 text-gray-800",
      darkColor: "dark:bg-gray-700 dark:text-gray-300",
    },
  },
  {
    href: "#",
    icon: FaCalendarAlt,
    text: "Calendario",
    badge: {
      text: "4",
      color: "bg-blue-100 text-blue-800",
      darkColor: "dark:bg-blue-900 dark:text-blue-300",
    },
  },
  {
    href: "#",
    icon: ImStatsDots,
    text: "Reportes",
  },
  {
    href: "#",
    icon: FaUsers,
    text: "Usuarios",
  },
  {
    href: "#",
    icon: MdPlace,
    text: "Escenarios",
  },
  {
    href: "#",
    icon: IoSettingsSharp,
    text: "Ajustes",
  },
  {
    href: "/admin",
    icon: MdAdminPanelSettings,
    text: "Master",
  },
  {
    href: "#",
    icon: IoIosLogOut,
    text: "Logout",
  },
];

export const empolyeesData = [
  {
    title: "Total Empolyees",
    icon: IoIosPerson,
    count: 200,
    bgColor: "bg-gray-100",
  },
  {
    title: "On Leave",
    icon: IoIosEyeOff,
    count: 15,
    bgColor: "bg-blue-100",
  },
  {
    title: "New Joinee",
    icon: IoIosPersonAdd,
    count: 25,
    bgColor: "bg-yellow-100",
  },
];

export const shortcutLink = [
  {
    title: "Fútbol",
    icon: IoFootball,
  },
  {
    title: "Futsal",
    icon: IoFootballOutline,
  },
  {
    title: "Básquetbol",
    icon: FaBasketball,
  },
  {
    title: "Voleibol",
    icon: FaVolleyball,
  },
  {
    title: "Rugby",
    icon: MdSportsRugby,
  },
];

export const users = [
  {
    name: "Robert Fox",
    country: "USA",
    role: "Python Developer",
    image: user01,
    bgColor: "bg-yellow-100",
  },
  {
    name: "Jane Doe",
    country: "UK",
    role: "Frontend Developer",
    image: user02,
    bgColor: "bg-blue-100",
  },
  {
    name: "John Smith",
    country: "Canada",
    role: "Backend Developer",
    image: user03,
    bgColor: "bg-gray-100",
  },
  {
    name: "Alice Johnson",
    country: "Australia",
    role: "Full Stack Developer",
    image: user01,
    bgColor: "bg-slate-100",
  },
];

export const events = [
  {
    date: "27 Sept",
    title: "Universiada Arequipa 2024",
    description: "El evento universitario más grande a nivel Nacional.",
  },
  {
    date: "05 Nov",
    title: "FISU AMERICA GAMES - Cali",
    description:
      "El evento universitario que reúne a los mejores estudiantes deportistas de América.",
  },
  {
    date: "25 Dici",
    title: "Navidad",
    description:
      "El evento no universitario donde se reúnen todas las familias a nivel mundial.",
  },
];

// ------- ==
// chart data, later we will use this!!!

// const options = {
//   series: [44, 55, 41],
//   options: {
//     chart: {
//       type: "donut",
//       height: 350,
//     },
//     labels: ["Desktop", "Tablet", "Mobile"],
//     colors: ["#FF5733", "#33FF57", "#3357FF"],
//     legend: {
//       position: "bottom",
//       labels: {
//         colors: darkMode ? "#dddddd" : "#000000",
//       },
//     },
//     dataLabels: {
//       style: {
//         colors: ["#dddddd"],
//       },
//     },
//     responsive: [
//       {
//         breakpoint: 480,
//         options: {
//           chart: {
//             width: 200,
//           },
//           legend: {
//             position: "bottom",
//           },
//         },
//       },
//     ],
//   },
// };

// ..........
// const chartConfig = {
//   series: [
//     {
//       name: "Sales",
//       data: [50, 40, 300, 320, 500, 350, 200, 230, 500],
//     },
//   ],
//   options: {
//     chart: {
//       type: "bar",
//       height: 240,
//       toolbar: {
//         show: false,
//       },
//     },
//     title: {
//       show: false,
//     },
//     dataLabels: {
//       enabled: false,
//     },
//     colors: ["#020617"],
//     plotOptions: {
//       bar: {
//         columnWidth: "40%",
//         borderRadius: 2,
//       },
//     },
//     xaxis: {
//       axisTicks: {
//         show: false,
//       },
//       axisBorder: {
//         show: false,
//       },
//       labels: {
//         style: {
//           colors: darkMode ? "#dddddd" : "#616161",
//           fontSize: "12px",
//           fontFamily: "inherit",
//           fontWeight: 400,
//         },
//       },
//       categories: [
//         "Apr",
//         "May",
//         "Jun",
//         "Jul",
//         "Aug",
//         "Sep",
//         "Oct",
//         "Nov",
//         "Dec",
//       ],
//     },
//     yaxis: {
//       labels: {
//         style: {
//           colors: darkMode ? "#dddddd" : "#616161",
//           fontSize: "12px",
//           fontFamily: "inherit",
//           fontWeight: 400,
//         },
//       },
//     },
//     grid: {
//       show: true,
//       borderColor: "#a0a0a0",
//       strokeDashArray: 5,
//       xaxis: {
//         lines: {
//           show: true,
//         },
//       },
//       padding: {
//         top: 5,
//         right: 20,
//       },
//     },
//     fill: {
//       opacity: 0.8,
//     },
//     tooltip: {
//       theme: "dark",
//     },
//   },
// };
